// Global
import React from 'react';

// Local
import SocialBarComponent, { SocialBarData } from './SocialBar';
import { Navigation } from '@generated/Navigation/SocialBar.model';
import { normalizeSitecoreImageUrl } from 'components/helpers/SitecoreWrappers/ImageWrapper/ImageWrapper';

export const Default = (props: Navigation.SocialBar.SocialBar_Component) => {
  const fields = props.fields;

  const platformItems = (fields?.socialMediaPlatformItems ??
    []) as Navigation.SocialBar.SocialMediaPlatformItem_Item[];

  const socialBarData: SocialBarData | undefined = fields
    ? {
        headlineText: fields.headlineText?.value || '',
        platforms: platformItems
          .map((item) => {
            const logo = item.fields?.socialMediaPlatformLogo?.value;
            return {
              url: item.fields?.socialMediaPlatformUrl?.value?.href || '',
              imageSrc: normalizeSitecoreImageUrl(logo?.src) || '',
              imageAlt: (logo?.alt as string) || item.fields?.title?.value || '',
              imageWidth: logo?.width ? Number(logo.width) : undefined,
              imageHeight: logo?.height ? Number(logo.height) : undefined,
              title: item.fields?.title?.value || '',
            };
          })
          .filter((platform) => platform.url && platform.imageSrc),
        // Legacy template URL fields used as a fallback when no Social Media
        // Platform items have been authored.
        facebookUrl: fields.facebookUrl?.value?.href || '',
        instagramUrl: fields.instagramUrl?.value?.href || '',
        xUrl: fields.xUrl?.value?.href || '',
        tiktokUrl: fields.tiktokUrl?.value?.href || '',
        pinterestUrl: fields.pinterestUrl?.value?.href || '',
        youtubeUrl: fields.youtubeUrl?.value?.href || '',
      }
    : undefined;

  return <SocialBarComponent socialBarData={socialBarData} />;
};
